import { CONFIG_PROVIDER, getPrefixCls, getIconCls, getSize } from '@ss/mtd-vue/es/utils/config';

var __vue_render__ = function __vue_render__() {
  var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;return _c('div', { class: [_vm.prefix, _vm._size ? _vm.prefix + "-" + _vm._size : ''] }, [_vm._t("default")], 2);
};
var __vue_staticRenderFns__ = [];

export default {
  render: __vue_render__,

  staticRenderFns: __vue_staticRenderFns__,

  name: 'MtdBreadcrumb',
  props: {
    separator: {
      type: String
    },
    separatorClass: {
      type: String
    },
    size: {
      type: String,
      default: ''
    }
  },
  provide: function provide() {
    return {
      breadcrumb: this
    };
  },

  inject: {
    config: {
      from: CONFIG_PROVIDER,
      default: {
        getPrefixCls: getPrefixCls,
        getIconCls: getIconCls,
        getSize: getSize
      }
    }
  },
  computed: {
    prefix: function prefix() {
      return this.config.getPrefixCls('breadcrumb');
    },
    _size: function _size() {
      return this.config.getSize(this);
    }
  }
};